import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import error from '../../assets/error.svg';

const NotFound = () => {
  return (
    <>
      <Container className="bg-white d-none d-sm-block">
        <Row className="mt-60 justify-content-center">
          <Col lg={5} className="mt-60">
            <h1 className="text-tangaroa mt-30">La página que buscas no existe</h1>
            <p className="mt-15">Inténtalo de nuevo o regresa a la página principal</p>
            <Link to="/" className="btn btn-primary mt-30" id="sbs-dsb-dgr-btn-mor">
              Regresar al Inicio
            </Link>
          </Col>
          <Col lg={5} className="">
            <img src={error} alt="noPoints-img" className="w-100" />
          </Col>
        </Row>
      </Container>

      <Container className="bg-white pb-15 d-block d-sm-none">
        <Row className="py-30 justify-content-center">
          <Col lg={12} className="">
            <h1 className="text-bismark mt-30">La página que buscas no existe</h1>
            <img src={error} alt="noPoints-img" className="w-100" />
            <p className="mt-15">Inténtalo de nuevo o regresa a la página principal</p>
            <Link to="/" className="btn btn-primary mt-15" id="sbs-dsb-dgr-btn-mor">
              Regresar al Inicio
            </Link>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NotFound;
